(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["selling-plans-widget"] && !Shopify.designMode) return;
  try {
    class SubscriptionPlansWidget extends HTMLElement {
    connectedCallback() {
      this.purchaseOptionRadios = Array.from(
        this.querySelectorAll('input[name^="SubscriptionWidget-PurchaseOption-"]')
      );
      this.planSelect = this.querySelector('select[data-selling-plan-select]');
      this.planRadios = Array.from(this.querySelectorAll('input[data-selling-plan-option]'));
      this.sellingPlanInput = this.querySelector('[data-selling-plan-input]');
      this.subscriptionDetails = Array.from(this.querySelectorAll('[data-subscription-details]'));
      this.subscriptionControls = this.querySelector('[data-subscription-controls]');
      this.subscriptionPrice = this.querySelector('[data-subscription-price]');

      this.onChange = this.onChange.bind(this);
      this.onVariantUpdate = this.onVariantUpdate.bind(this);

      this.addEventListener('change', this.onChange);

      const target = this.closest('.shopify-section, dialog') || document;
      target.addEventListener('variant:update', this.onVariantUpdate);

      this.applySellingPlanFromUrl();
      this.syncFromDom();
      this.updateUrlFromState();
      this.bindInfoTooltip();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      const target = this.closest('.shopify-section, dialog') || document;
      target.removeEventListener('variant:update', this.onVariantUpdate);
      if (this._infoTooltipAbort) {
        this._infoTooltipAbort.abort();
        this._infoTooltipAbort = null;
      }
    }

    /**
     * Positions the info tooltip with fixed coordinates so it stays aligned to the trigger
     * and inside the viewport (avoids overflow/stacking issues in sticky PDP layouts).
     */
    bindInfoTooltip() {
      const btn = this.querySelector('.subscription-widget__info-button');
      const tip = this.querySelector('.subscription-widget__info-tooltip');
      if (!(btn instanceof HTMLButtonElement) || !(tip instanceof HTMLElement)) return;

      if (this._infoTooltipAbort) {
        this._infoTooltipAbort.abort();
      }
      this._infoTooltipAbort = new AbortController();
      const { signal } = this._infoTooltipAbort;

      const viewportPad = 12;
      const gap = 6;
      const arrowInset = 14;

      const hide = () => {
        tip.classList.remove('is-visible', 'subscription-widget__info-tooltip--flip');
        btn.setAttribute('aria-expanded', 'false');
      };

      const position = () => {
        if (!tip.classList.contains('is-visible')) return;

        const br = btn.getBoundingClientRect();
        tip.classList.remove('subscription-widget__info-tooltip--flip');

        const tw = tip.offsetWidth;
        const th = tip.offsetHeight;
        if (tw === 0 || th === 0) return;

        let top = br.bottom + gap;
        let flip = false;

        if (top + th > window.innerHeight - viewportPad && br.top - gap - th > viewportPad) {
          top = br.top - gap - th;
          flip = true;
        }

        top = Math.max(viewportPad, Math.min(top, window.innerHeight - viewportPad - th));

        if (flip) {
          tip.classList.add('subscription-widget__info-tooltip--flip');
        }

        let left = br.left + br.width / 2 - tw / 2;
        left = Math.max(viewportPad, Math.min(left, window.innerWidth - viewportPad - tw));

        tip.style.left = `${Math.round(left)}px`;
        tip.style.top = `${Math.round(top)}px`;

        const btnCenterX = br.left + br.width / 2;
        const arrowX = Math.max(arrowInset, Math.min(btnCenterX - left, tw - arrowInset));
        tip.style.setProperty('--subscription-widget-tooltip-arrow-x', `${Math.round(arrowX)}px`);
      };

      const show = () => {
        tip.classList.add('is-visible');
        btn.setAttribute('aria-expanded', 'true');
        window.requestAnimationFrame(() => {
          position();
          window.requestAnimationFrame(() => position());
        });
      };

      let hideTimer = 0;

      const scheduleHide = () => {
        window.clearTimeout(hideTimer);
        hideTimer = window.setTimeout(() => {
          hide();
        }, 140);
      };

      const cancelHide = () => {
        window.clearTimeout(hideTimer);
      };

      const coarsePointer =
        typeof window.matchMedia === 'function' && window.matchMedia('(pointer: coarse)').matches;

      if (!coarsePointer) {
        btn.addEventListener(
          'mouseenter',
          () => {
            cancelHide();
            show();
          },
          { signal }
        );

        btn.addEventListener(
          'mouseleave',
          () => {
            scheduleHide();
          },
          { signal }
        );

        btn.addEventListener(
          'focusin',
          () => {
            cancelHide();
            show();
          },
          { signal }
        );

        btn.addEventListener(
          'focusout',
          () => {
            scheduleHide();
          },
          { signal }
        );
      } else {
        btn.addEventListener(
          'click',
          () => {
            if (tip.classList.contains('is-visible')) {
              hide();
            } else {
              show();
            }
          },
          { signal }
        );
      }

      document.addEventListener(
        'click',
        (event) => {
          if (!tip.classList.contains('is-visible')) return;
          const t = event.target;
          if (!(t instanceof Node)) return;
          if (btn.contains(t)) return;
          hide();
        },
        { signal }
      );

      document.addEventListener(
        'keydown',
        (event) => {
          if (event.key !== 'Escape') return;
          if (!tip.classList.contains('is-visible')) return;
          hide();
          btn.blur();
        },
        { signal }
      );

      window.addEventListener(
        'scroll',
        () => {
          if (tip.classList.contains('is-visible')) position();
        },
        { capture: true, passive: true, signal }
      );

      window.addEventListener(
        'resize',
        () => {
          if (tip.classList.contains('is-visible')) position();
        },
        { passive: true, signal }
      );
    }

    getSelectedPurchaseOption() {
      const selected = this.purchaseOptionRadios.find((radio) => radio.checked);
      return selected?.value || 'subscription';
    }

    getSelectedSellingPlanId() {
      if (this.planSelect instanceof HTMLSelectElement) return this.planSelect.value || '';
      const checked = this.planRadios?.find((r) => r.checked);
      return checked?.value ?? '';
    }

    setPurchaseOption(value) {
      for (const radio of this.purchaseOptionRadios) {
        radio.checked = radio.value === value;
      }
    }

    applySellingPlanFromUrl() {
      const url = new URL(window.location.href);
      const sellingPlanId = url.searchParams.get('selling_plan');
      if (!sellingPlanId) return;

      if (this.planSelect instanceof HTMLSelectElement) {
        const hasOption = Array.from(this.planSelect.options).some((opt) => opt.value === sellingPlanId);
        if (!hasOption) return;
        this.planSelect.value = sellingPlanId;
      } else if (this.planRadios?.length) {
        const radio = this.planRadios.find((r) => r.value === sellingPlanId);
        if (!radio) return;
        radio.checked = true;
      } else return;

      this.setPurchaseOption('subscription');
    }

    syncFromDom() {
      const purchaseOption = this.getSelectedPurchaseOption();
      const isSubscription = purchaseOption === 'subscription';

      for (const el of this.subscriptionDetails) {
        el.hidden = !isSubscription;
      }

      if (this.subscriptionControls instanceof HTMLElement) {
        this.subscriptionControls.hidden = !isSubscription;
      }

      if (!(this.sellingPlanInput instanceof HTMLInputElement)) return;

      if (!isSubscription) {
        this.sellingPlanInput.value = '';
      } else {
        const planId = this.getSelectedSellingPlanId();
        this.sellingPlanInput.value = planId || '';
      }

      if (this.subscriptionPrice) {
        let priceText = '';
        if (this.planSelect instanceof HTMLSelectElement) {
          const option = this.planSelect.selectedOptions?.[0];
          priceText = option?.dataset?.sellingPlanPriceText ?? '';
        } else {
          const checked = this.planRadios?.find((r) => r.checked);
          priceText = checked?.dataset?.sellingPlanPriceText ?? '';
        }
        if (priceText) this.subscriptionPrice.textContent = priceText;
      }
    }

    updateUrlFromState() {
      const url = new URL(window.location.href);

      const purchaseOption = this.getSelectedPurchaseOption();
      const sellingPlanId = purchaseOption === 'subscription' ? this.getSelectedSellingPlanId() : '';

      if (sellingPlanId) {
        url.searchParams.set('selling_plan', sellingPlanId);
      } else {
        url.searchParams.delete('selling_plan');
      }

      history.replaceState({}, '', url.toString());
    }

    onChange(event) {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;

      if (
        target.matches('input[name^="SubscriptionWidget-PurchaseOption-"]') ||
        target.matches('select[data-selling-plan-select]') ||
        target.matches('input[data-selling-plan-option]')
      ) {
        this.syncFromDom();
        this.updateUrlFromState();
      }
    }

    onVariantUpdate(event) {
      const detail = event?.detail;
      if (!detail?.data) return;

      const doc = detail.data.html;
      if (!(doc instanceof Document)) return;

      const selector = `subscription-plans-widget[data-section-id="${this.dataset.sectionId}"][data-block-id="${this.dataset.blockId}"]`;
      let next = doc.querySelector(selector);
      if (!(next instanceof HTMLElement)) {
        const fallbackSelector = `subscription-plans-widget[data-block-id="${this.dataset.blockId}"]`;
        next = doc.querySelector(fallbackSelector);
      }
      if (!(next instanceof HTMLElement)) {
        this.hidden = true;
        if (this.sellingPlanInput instanceof HTMLInputElement) {
          this.sellingPlanInput.value = '';
        }
        const url = new URL(window.location.href);
        if (url.searchParams.has('selling_plan')) {
          url.searchParams.delete('selling_plan');
          history.replaceState({}, '', url.toString());
        }
        return;
      }

      this.replaceWith(next);
    }
  }

  if (!customElements.get('subscription-plans-widget')) {
    customElements.define('subscription-plans-widget', SubscriptionPlansWidget);
  }
  } catch(e) { console.error(e); }
})();

})();
